import React from "react";
import { EditorTools, EditorToolsSettings } from "@progress/kendo-react-editor";
import { JSX } from "react/jsx-runtime";

const { BackColor } = EditorTools;

/**
 * Custom BackColor component with predefined styling and color palette
 * Provides background color selection functionality for the WYSIWYG editor
 */
export const CustomBackColor = (
  props: JSX.IntrinsicAttributes & EditorTools.BackColorProps
) => (
  <BackColor
    {...props}
    colorPickerProps={{
      ...props.colorPickerProps,
      defaultValue: "#ffffff",
      svgIcon: EditorToolsSettings.backColor.colorPickerProps.svgIcon,
      paletteSettings: {
        ...props.colorPickerProps?.paletteSettings,
        palette: "basic"
      }
    }}
  />
);

export default CustomBackColor;
